<template>
  <v-slide-y-transition>
    <span>
      {{ truncarTexto }}
      <v-btn
        v-if="elTextoEsMayor"
        class="mb-1"
        text
        x-small
        color="blue"
        @click="cambiarCantidadCaracteres">
        {{ textDelBoton }}
      </v-btn>
    </span>
  </v-slide-y-transition>
</template>

<script>
export default {
  name: 'CortarTextos',
  props: {
    texto: {
      type: String,
      required: true,
    },
    cantidadCaracteres: {
      type: Number,
      required: false,
      default: 140,
    },
  },
  data() {
    return {
      caracteres: this.cantidadCaracteres,
    };
  },
  methods: {
    cambiarCantidadCaracteres() {
      this.caracteres = this.caracteres === 140 ? this.texto.length : 140;
    },
  },
  computed: {
    elTextoEsMayor() {
      return this.texto.length > this.cantidadCaracteres;
    },
    textDelBoton() {
      if (this.texto.length > this.caracteres) {
        return 'Mostrar más';
      }
      return 'Mostrar menos';
    },
    truncarTexto() {
      if (this.texto.length <= this.caracteres) {
        return this.texto;
      }

      return `${String(this.texto).substr(0, this.caracteres)} \u2026`;
    },
  },
};
</script>

<style lang="scss">

</style>
